import { create } from "zustand";

interface PopupState {
  chatPopupOpen: boolean;
  escalationPopupOpen: boolean;
  setChatPopupOpen: (isOpen: boolean) => void;
  setEscalationPopupOpen: (isOpen: boolean) => void;
}

export const usePopupStore = create<PopupState>((set) => ({
  chatPopupOpen: false,
  escalationPopupOpen: false,
  setChatPopupOpen: (isOpen) => set({ chatPopupOpen: isOpen }),
  setEscalationPopupOpen: (isOpen) => set({ escalationPopupOpen: isOpen }),
}));
